
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { FinancialAssumptions } from './types';

interface CashFlowTabProps {
  assumptions: FinancialAssumptions;
  onInputChange: (section: keyof FinancialAssumptions, field: string, value: string | number) => void;
}

export function CashFlowTab({ assumptions, onInputChange }: CashFlowTabProps) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="ocfGrowth">Operating Cash Flow Growth (%)</Label>
          <Input
            id="ocfGrowth"
            type="number"
            value={assumptions.cashFlow.operatingCashFlowGrowth}
            onChange={(e) => onInputChange('cashFlow', 'operatingCashFlowGrowth', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="capexProjection">Capital Expenditure Projection (NZD)</Label>
          <Input
            id="capexProjection"
            type="number"
            value={assumptions.cashFlow.capitalExpenditureProjection}
            onChange={(e) => onInputChange('cashFlow', 'capitalExpenditureProjection', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="workingCapitalChange">Working Capital Change (NZD)</Label>
          <Input
            id="workingCapitalChange"
            type="number"
            value={assumptions.cashFlow.workingCapitalChange}
            onChange={(e) => onInputChange('cashFlow', 'workingCapitalChange', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="dividendPayout">Dividend Payout Ratio (%)</Label>
          <Input
            id="dividendPayout"
            type="number"
            value={assumptions.cashFlow.dividendPayoutRatio}
            onChange={(e) => onInputChange('cashFlow', 'dividendPayoutRatio', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="fcfGrowth">Free Cash Flow Growth (%)</Label>
          <Input
            id="fcfGrowth"
            type="number"
            value={assumptions.cashFlow.freeCurrentFlowGrowth}
            onChange={(e) => onInputChange('cashFlow', 'freeCurrentFlowGrowth', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}
